<template>
  <div class="learners">
    <ul>
      <li v-for="learner in learners">
        <input
          type="email"
          :readonly="learner.fixed"
          :value="learner.email"
          @input="
            learner.email = $event.target.value;
            $emit('change', validLearners);
          "
          placeholder="Enter an email address"
        />
        <a
          v-if="!learner.fixed && canDelete"
          href=""
          @click.prevent="removeLearner(learner)"
          class="remove-learner"
          >&times;</a
        >
      </li>
    </ul>
    <div class="add-learners" v-if="canAdd || maxMessage">
      <p>
        <a v-if="canAdd" @click.prevent="addLearner" href="">
          {{ addMessage || "Add more learners to your subscription" }}
        </a>
      </p>
      <p v-if="maxMessage" v-html="maxMessage"></p>
    </div>
  </div>
</template>

<style lang="less" scoped>
.license-count {
  .box {
    background: white;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 11px 35px 13px 15px;
  }
}
.learners {
  ul {
    margin: 0.5em 0 0.5em 0;
  }

  li {
    background: white;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 0px;
    position: relative;
    margin-bottom: 0.5em;

    input {
      width: 100%;
      padding: 11px 35px 13px 15px;
      border-radius: 5px;
    }

    .remove-learner {
      display: block;
      position: absolute;
      right: 0px;
      top: 0px;
      padding: 10px 15px;
      color: #999;
      &:hover {
        color: #000;
      }
    }
  }

  .add-learners {
    margin-top: 0.3em;
    margin-bottom: 2.5em;

    :deep(a) {
      color: rgba(0, 0, 0, 0.5);
      text-decoration: underline;

      &:hover {
        color: rgba(0, 0, 0, 1);
      }
    }

    p {
      margin-bottom: 0.5em;
    }
  }
}
</style>

<script>
import { clone } from "lodash";

export default {
  data: function() {
    return {
      learners: clone(this.initialLearners),
    };
  },
  props: {
    initialLearners: Array,
    addMessage: String,
    maxMessage: String,
    max: Number,
    min: { type: Number, default: 1 },
  },
  computed: {
    validLearners() {
      return this.learners.filter((learner) =>
        learner.email.match(/^\S+@\S+\.\S+$/)
      );
    },
    canDelete() {
      return this.learners.length > this.min;
    },
    canAdd() {
      return !this.max || this.learners.length < this.max;
    },
  },
  mounted: function() {
    this.enforceMinLearners();
  },
  watch: {
    min: function() {
      this.enforceMinLearners();
    },
    max(max) {
      if (max) {
        while (this.learners.length > max) {
          this.learners.pop();
        }
      }
      this.$emit("change", this.validLearners);
    },
  },
  methods: {
    removeLearner(learner) {
      if (!learner.fixed) {
        let index = this.learners.indexOf(learner);
        this.learners.splice(index, 1);
        if (this.learners.length === this.min - 1) {
          this.learners.push({ email: "" });
        }
        this.$emit("change", this.validLearners);
      }
    },
    addLearner() {
      if (!this.max || this.learners.length < this.max) {
        this.learners.push({ email: "" });
      }
    },
    enforceMinLearners() {
      for (let i = this.learners.length; i < this.min; i++) {
        this.learners.push({ email: "" });
      }
    },
  },
};
</script>
